import { render, staticRenderFns } from "./ProductRule.vue?vue&type=template&id=638469cf&scoped=true"
import script from "./ProductRule.vue?vue&type=script&lang=js"
export * from "./ProductRule.vue?vue&type=script&lang=js"
import style0 from "./ProductRule.vue?vue&type=style&index=0&id=638469cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638469cf",
  null
  
)

export default component.exports